import { render, staticRenderFns } from "./DashboardApprovalAging.vue?vue&type=template&id=6bf94af4&scoped=true&"
import script from "./DashboardApprovalAging.vue?vue&type=script&lang=js&"
export * from "./DashboardApprovalAging.vue?vue&type=script&lang=js&"
import style0 from "./DashboardApprovalAging.vue?vue&type=style&index=0&id=6bf94af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf94af4",
  null
  
)

export default component.exports